
export class Serialisable {
    public fromJson(json: string): any {
        let sourceObject:Object = JSON.parse(json);
        return this.fromObject(sourceObject);
    }

    public fromObject(sourceObject: Object): any {
        for (let propertyName in sourceObject) {
            this[propertyName] = sourceObject[propertyName]
        }

        return this;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/serialisable.ts